import(/* webpackMode: "eager", webpackExports: ["BodyScrollLockReset"] */ "/vercel/path0/apps/web/src/components/BodyScrollLockReset.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/components/footer/FooterClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/components/navbar/NavbarClient.tsx");
